<template>
  <svg
    id="svg4"
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs8" />
    <!-- eslint-disable max-len -->
    <path
      id="path2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m 7.71428,1.71428 c -0.47315,0 -0.85715,0.384 -0.85715,0.85715 V 3.42857 H 10.2857 V 2.57143 c 0,-0.47315 -0.384,-0.85715 -0.85714,-0.85715 z M 12,3.42857 V 2.57143 C 12,1.15114 10.8489,0 9.42857,0 H 7.71429 C 6.294,0 5.14286,1.15114 5.14286,2.57143 V 3.42857 H 0.857143 C 0.384,3.42857 0,3.81257 0,4.28571 0,4.75886 0.384,5.14286 0.857143,5.14286 h 0.09 L 2.40686,18.2837 c 0.14485,1.3029 1.24543,2.2877 2.556,2.2877 H 12.18 c 1.3106,0 2.4111,-0.9848 2.5551,-2.2877 L 16.1957,5.14286 h 0.09 c 0.4732,0 0.8572,-0.384 0.8572,-0.85715 0,-0.47314 -0.384,-0.85714 -0.8572,-0.85714 z"
      fill="currentColor"
    />
    <!-- eslint-enable -->
  </svg>
</template>

<script>
export default {
  name: 'DeleteSolidIcon'
}
</script>
